import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import type { TGetProjectListResponse } from "../types/projects";
import { TProject } from "@/zapi-frontend/stores/project";
import { AxiosResponse } from "axios";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { limitProjectsForDisplay } from "@/zapi-frontend/shared/lib/limitProjectsForDisplay";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";
import $api from "../api/axios";

export const GET_PROJECTS_LIST_KEY = "getProjectsList";

export type TProjectsListAxiosBody = { data: TGetProjectListResponse[] };

type TOptionsType = Partial<UseQueryOptions<AxiosResponse<TProjectsListAxiosBody>, Error, TProject[]>>;

export function useGetProjectsList(options?: TOptionsType) {
  const { currentOrganizationId } = useOrganizationStore();
  const organizationName = useMeStore((s) => s.organizationName);

  return useQuery({
    queryKey: [GET_PROJECTS_LIST_KEY, currentOrganizationId],
    queryFn: () => $api.get<TProjectsListAxiosBody>("/projects"),
    select: (response) => {
      const projects = response.data.data.map((p) => ({
        ...p,
        projectTemplateName: "",
        chatEnabled: true,
        instructionsUpdatedAt: null
      }));
      return limitProjectsForDisplay(projects, organizationName);
    },
    ...options
  });
}
